export default {
  toggle: props => ({
    animation: { rotateZ: props.node.toggled ? 90 : 0 },
    duration: 300,
  }),
  drawer: () => ({
    enter: {
      animation: 'slideDown',
      duration: 300,
    },
    leave: {
      animation: 'slideUp',
      duration: 300,
    },
  }),
};
